import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLiveWeak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLiveWeak"><Path d="M15.8891 8.11084C18.037 10.2587 18.037 13.7411 15.8891 15.889M8.11091 15.889C5.96303 13.7411 5.96303 10.2587 8.11091 8.11084M13.5 11.9999C13.5 12.8284 12.8284 13.4999 12 13.4999C11.1716 13.4999 10.5 12.8284 10.5 11.9999C10.5 11.1715 11.1716 10.4999 12 10.4999C12.8284 10.4999 13.5 11.1715 13.5 11.9999Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLiveWeak;
